import { branchInfoHandler, branchListHandler } from '@api/branch-api';
import BranchStorage from "../storage/branch.storage";
import store from "@store"
import router from '../../router'

const branch = {
  namespaced: true,
  state: {
    branchUUID: BranchStorage.branchUUID,
    branchInfo: BranchStorage.branchInfo,
    branchList: null,
  },
  getters: {
    branchUUID(state) {
      return state.branchUUID;
    },
    branchInfo(state) {
      return state.branchInfo;
    },
    branchList(state) {
      return state.branchList;
    },
  },
  mutations: {
    SET_BRANCH_UUID(state, branchUUID) {
      state.branchUUID = branchUUID;
      BranchStorage.branchUUID = branchUUID;
    },
    SET_BRANCH_INFO(state, payload) {
      state.branchInfo = payload;
      BranchStorage.branchInfo = payload;
    },
    SET_BRANCH_LIST(state, payload) {
      state.branchList = payload;
    },
  },
  actions: {
    async setBranch({ commit, dispatch }, branchUUID = null) {
      if (branchUUID != BranchStorage.branchUUID) {
        if (branchUUID) {
          await commit('SET_BRANCH_UUID', branchUUID)
        }
        await dispatch('fetchBranchInfo', branchUUID)
        await commit('SET_BRANCH_UUID', branchUUID)
      }
      if (!branchUUID) {
        throw new Error("Have no branch UUID")
      }
    },
    async setBranchNull({ commit, dispatch }, branchUUID = null) {
        await commit('SET_BRANCH_UUID', branchUUID)
    },
    async fetchBranchInfo ({ commit }, branch_uuid) {
      return await branchInfoHandler(branch_uuid)
        .then(async (result) => {
          if(result.data.data != null){
            await commit('SET_BRANCH_INFO', result.data.data)
            return result.data.data;
          }
          throw 'Not Found branch info'
        })
        .catch((err) => {});
    },
    async fetchBranchList({ commit }) {
      return await branchListHandler()
          .then(res => {
              const branchList = res.data.data
                  .filter(
                      branch => !!branch.fs_crm_enable && !!branch.package && branch.crm_system_id === 2 && !branch.crm_expired,
                  )
                  .map(branch => {
                      return {
                          address: branch.address,
                          branchName: branch.name,
                          branchUUID: branch.branch_uuid,
                          disabledFlag: !!branch.crm_expired,
                          fsCrmEnable: !!branch.fs_crm_enable,
                          latitude: branch.latitude,
                          logoImgKey: branch.logo_img_key,
                          longitude: branch.longitude,
                          restaurantName: branch.restaurant_name,
                      }
                  })
              commit('SET_BRANCH_LIST', branchList)
              return branchList
          })
          .catch(err => {
              commit('SET_BRANCH_LIST', null)
              throw err
          })
    },
    async forceLogoutWhenExpiredAllCRMBranch(context){
      const auth = store.getters["auth/isLoggedIn"];
      if(auth){
        await context.dispatch('fetchBranchList')
        const branchList =  context.state.branchList;
        const activeBranches = branchList.filter( branch => branch.fsCrmEnable )
        if(activeBranches.length == 0){
          await store.dispatch('auth/doLogout');
          router.push({ name: "Login" });
        }
      }
    }
  }
}

export default branch
